import { render, staticRenderFns } from "./InputCheckbox.vue?vue&type=template&id=08e25ec0&"
import script from "./InputCheckbox.vue?vue&type=script&lang=js&"
export * from "./InputCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08e25ec0')) {
      api.createRecord('08e25ec0', component.options)
    } else {
      api.reload('08e25ec0', component.options)
    }
    module.hot.accept("./InputCheckbox.vue?vue&type=template&id=08e25ec0&", function () {
      api.rerender('08e25ec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TestForm/components/InputCheckbox/InputCheckbox.vue"
export default component.exports